module.exports = __webpack_public_path__ + "img/roulants.c1622bb.svg";